import { render } from "./BusquedaXPlaca.vue?vue&type=template&id=bc21f29e&scoped=true"
import script from "./BusquedaXPlaca.vue?vue&type=script&lang=js"
export * from "./BusquedaXPlaca.vue?vue&type=script&lang=js"

import "./BusquedaXPlaca.vue?vue&type=style&index=0&id=bc21f29e&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.29_vue@3.5.29_webpack@4.47.0_supports-color@6.1.0_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc21f29e"]])

export default __exports__